// vanilla js implementation of loader hide after the dom is loaded
function loaderfadeout() {
    var loader = document.getElementById("loader");
    if(loader){
        // do a fade out effect
        loader.style.transition = "opacity 0.5s";
        loader.style.opacity = "0";
        setTimeout(function() {
            loader.style.display = "none";
        }, 500);
    }
}
document.addEventListener("DOMContentLoaded", loaderfadeout);
// fallback to hide loader after 2 seconds
setTimeout(loaderfadeout, 2000);